<template>
  <v-container fluid class="px-0 py-0 mx-0">
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="image-background white--text">
          <v-card-media height="200px">
          </v-card-media>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex x12>
        <v-container>
          <v-layout row wrap>
            <v-flex xs12 class="mb-5 pb-4">
              <v-form v-model="valid" autocomplete="off">
              <v-text-field label="Contraseña" v-model="password" :append-icon-cb="() => (visible = !visible)" :append-icon="visible ? 'visibility' : 'visibility_off'"
                :type="visible ? 'password' : 'text'" required :rules="[() => password.length > 0 || 'No hay contraseña']"
                autocomplete="nope"></v-text-field>
              </v-form>
              <v-btn large block class="caption capitalize font-600" color="primary" @click="resetPassword">Cambiar</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import HTTP from '@/axios-config'

export default {
  name: 'Reset',
  data () {
    return {
      password: '',
      valid: true,
      visible: true
    }
  },
  methods: {
    resetPassword () {
      let requestResetPassword = {
        password: this.password
      }
      HTTP.post('/user/resetPassword/' + this.$route.params.id, requestResetPassword)
        .then(function (response) {
          this.$bus.$emit('event-toast', response.data.message)
          setTimeout(() => this.$router.push('/login'), 5500)
        }.bind(this))
        .catch(function (error) {
          if (error.response) this.$bus.$emit('event-toast', error.response.data.message)
        }.bind(this))
    }
  }
}

</script>

<style scoped>
  .image-background {
    background-image: url('./../assets/login_background.jpg') !important;
    background-size: cover !important;
    background-repeat: no-repeat !important
  }

  .btn--active .btn__content:before,
  .btn:hover .btn__content:before,
  .btn:focus .btn__content:before {
    background-color: transparent !important;
  }

  .font-600 {
    font-weight: 600 !important;
  }

  .capitalize {
    text-transform: capitalize !important;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Reset.vue